export enum StatusEnumDto {
    Requested = "requested",
    Authorized = "authorized",
    Management = "management",
    FavorableResolution = "favorable_resolution",
    DesfavorableResolution = "desfavorable_resolution",
}